import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { InventoryBoxQrsListItem } from "../../inventory.types";
import { requestGetInventoryBoxQr } from "./getInventoryBoxQr.request";

const useGetInventoryBoxQr = (
  boxId: string | undefined | null,
  options?: QueryOptions<InventoryBoxQrsListItem, ApiServiceError<ApiError>>
) => {
  const { data: boxItem, ...rest } = useQuery({
    queryKey: ["inventory-box-admin", "one-qr", boxId],
    queryFn: async () => await requestGetInventoryBoxQr(String(boxId)),
    onError: toastServerError,
    enabled: !!boxId,
    cacheTime: 0,
    ...options
  });

  return { boxItem, ...rest };
};

export default useGetInventoryBoxQr;
